import SlBadge from '@shoelace-style/shoelace/dist/react/badge/index.js';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import './FilterBreadcrumbs.css';
// import '@shoelace-style/shoelace/dist/themes/light.css';

export default function FilterBreadcrumbs({selectedFilters, handleRemove, setSelectedFilters}){
    console.log(selectedFilters);
    const entries = Object.entries(selectedFilters)
        .filter(([key]) => key !== 'extractedTime' && key !== 'updateTime')
        .map(([key, values]) => {
        const valueCount = values.length;
        return {
            key,
            values,
            valueCount: valueCount
        };
    });
    console.log(entries);
    if(entries.length === 0) return null;

    function handleRemoveBadge(filterKey){
        setSelectedFilters((prev) => ({
            ...prev,
            [filterKey]: []
        }));
    }

    return(
        <div className="breadcrumbs-container">
            {entries.flatMap(({key,valueCount}) => valueCount > 0 && 
            (<SlBadge
            key={key}
  className="cds-badge--appearance-light breadcrumb-badge"
  size="medium"
  variant="light"
  pill
>
  <span className="cds-text-truncate">
    {key=== "sourceNames" ? "Source" : key=== "categories" ? "Categories" : key === "countries" ? "Countries" : key === "regions" ? "Region" : key === "states" ? "States" : key ==="extractedTime" ? "Extracted Time" : key==="updateTime" ? "Update Time" : ""}
  </span>
  <span className="cds-text-truncate">
    ({valueCount})
  </span>
  <SlIcon
    size="sm"
    src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0idmFyKC0tY2RzLWljb24td2VpZ2h0LCAxLjUpIiBzdHlsZT0iYm94LXNpemluZzogYm9yZGVyLWJveDsgb3ZlcmZsb3c6IHZpc2libGU7IHBhZGRpbmc6IHZhcigtLWNkcy1pY29uLXBhZGRpbmcsIDApOyB0cmFuc2l0aW9uOiB2YXIoLS1jZHMtaWNvbi10cmFuc2l0aW9uLCAwcyk7Ij48ZyBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik00LjUgMTkuNSAxOS41IDQuNSIvPjxwYXRoIGQ9Ik00LjUgNC41IDE5LjUgMTkuNSIvPjwvZz48L3N2Zz4="
    weight="semibold"
    className='breadcrumb-close'
    onClick={() => handleRemoveBadge(key)}
  />
</SlBadge>)
        )}
        </div>
    )

}